import React from 'react';
import isNumber from 'lodash/isNumber';
import { Props as EarningsCalculatorProps } from '../../../EarningsCalculator/dsPresets/EarningsCalculator/EarningsCalculator';
import { EarningsCalculator, parseFloatOrFallback } from '../../../EarningsCalculator';
import DollarPriceInput, { Props as DollarPriceInputProps } from '../../DollarPriceInput';

export interface Props
  extends DollarPriceInputProps, Pick<EarningsCalculatorProps, 'productType' | 'isResale'> {}

/** DollarPriceInput w/ built-in EarningsCalculator in the `details` */
export const PriceInputWithEarnings = React.forwardRef<HTMLInputElement, Props>(
  ({ value, productType, isResale, placeholder = 0, ...remainingDollarPriceInputProps }, ref) => {
    return (
      <DollarPriceInput
        ref={ref}
        value={value}
        details={
          <EarningsCalculator
            price={parseFloatOrFallback(`${value ?? ''}`, isNumber(placeholder) ? placeholder : 0)}
            productType={productType}
            isResale={isResale}
          />
        }
        placeholder={placeholder}
        {...remainingDollarPriceInputProps}
      />
    );
  }
);
PriceInputWithEarnings.displayName = 'PriceInputWithEarnings';

export default PriceInputWithEarnings;
